import { RaRecord, useGetList } from 'ra-core'
import { APIEntity } from '../api/entities'
import { getDefaultListParams } from '../utils'
import { useQueryClient } from 'react-query'

// the fetching seems to perform in a wrong way over 100 record
export const useKGetList = <T extends RaRecord>(resource: APIEntity) => {
  const queryClient = useQueryClient()

  /**
   * React Admin's getList hook caches a `getOne` query for every element in the list response
   * This will make the edit views use the list model and not re-fetch the detail model, which is not always the same of the list model
   * Thus here we override that behavior by deleting all getOne cached elements
   */
  const clearDetailCache = () => queryClient.removeQueries([resource, 'getOne'])

  const queryOptions = {
    onSuccess: clearDetailCache,
  }

  return (
    useGetList<T>(resource, getDefaultListParams(), queryOptions).data ?? []
  )
}
